import { z } from 'zod';
import { CrewClaimResolutionMethodEnum, CrewClaimTypeEnum, } from '../../enums/crew.js';
import { enumToZodLiteralUnion } from '../../zodExtensions.js';
import { claimAddress } from './address.js';
import { claimLineItemCreate } from './claimLineItem.js';
import { customerUiEventCustomField } from './customField.js';
import { Pegasus } from './pegasus.js';
import { rate, returnShipmentMethod } from './shipmentRate.js';
export const calculatedOrderLineItem = claimLineItemCreate.extend({
    grams: z.coerce.number(),
});
export const calculatedOrder = z.object({
    id: z.number(),
    claimType: enumToZodLiteralUnion(CrewClaimTypeEnum),
    calculatedLineItems: z.array(calculatedOrderLineItem),
    returnShipment: returnShipmentMethod.nullish(),
    toCustomerRate: rate.nullish(),
    exchangeMethod: z
        .union([z.literal('instant'), z.literal('standard')])
        .optional(),
    creditResolutionMethods: z.array(z.union([
        z.literal(CrewClaimResolutionMethodEnum.refund),
        z.literal(CrewClaimResolutionMethodEnum.giftCard),
    ])),
});
export const calculatedOrderShipmentQuote = calculatedOrder
    .omit({
    returnShipment: true,
    toCustomerRate: true,
})
    .extend({
    address: claimAddress,
});
export const calculatedOrderNoResolutions = calculatedOrder
    .omit({
    returnShipment: true,
    toCustomerRate: true,
    calculatedLineItems: true,
})
    .extend({
    calculatedLineItems: z.array(calculatedOrderLineItem.omit({
        requestedResolutionMethodEnum: true,
    })),
});
// --------- response bodies -----------------------
export const calculatedAfterReasonSelection = z.object({
    eventPolicyEnforcement: Pegasus.eventPolicyEnforcement.nullable(),
    eventCustomFields: customerUiEventCustomField.nullable(),
});
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const toCustomer = z.object({
    tax: z.number(),
    subtotal: z.number(),
    shipping: z.number(),
    total: z.number(),
});
const fromCustomer = z.object({
    // inclusive of fees, incentives, and shipping
    total: z.number(),
    adjustments: z.object({
        fee: z.number(),
        feeLabel: z.string().optional(),
        incentive: z.number(),
        shipping: z.number(),
    }),
    lineItems: z.object({
        tax: z.number(),
        subtotal: z.number(),
        total: z.number(),
    }),
});
const ReturnSummarySectionType = {
    SHIPPING: 'SHIPPING',
    RETURN_SHIPPING: 'RETURN_SHIPPING',
    INCENTIVE: 'INCENTIVE',
    FEE: 'FEE',
    TAX: 'TAX',
    SUBTOTAL: 'SUBTOTAL',
};
const financialSection = z.object({
    total: z.number(),
    lineItems: z.array(calculatedOrderLineItem.pick({
        originalStoreOrderLineItemId: true,
        unitPrice: true,
        unitTax: true,
    })),
    sections: z.array(z.object({
        type: z.nativeEnum(ReturnSummarySectionType),
        label: z.string(),
        amount: z.number(),
    })),
});
const returnSummary = z.object({
    credits: financialSection,
    deductions: financialSection,
    balance: z.number(),
    paymentIntent: z
        .object({
        clientSecret: z.string(),
        amount: z.number(),
        idFromPlatform: z.string(),
    })
        .optional(),
});
export const calculatedBeforeClaimSubmission = z.object({
    balance: z.number(),
    authorizedAmount: z.number(),
    toCustomer: toCustomer.nullable(),
    fromCustomer,
    returnSummary: returnSummary.optional(),
});
//# sourceMappingURL=calculatedOrder.js.map